import React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "@/context/LocaleContext";
import { AccountMenu } from "@/components/AccountMenu";
import { PROJECTS_LIST_PATH } from "@/lib/routes";

export default function NotFoundPage() {
  const { t } = useLocale();

  return (
    <div className="min-h-screen grain flex flex-col items-center justify-center px-4 pb-24 relative">
      <div className="absolute top-4 right-4">
        <AccountMenu helpReturnTo={PROJECTS_LIST_PATH} />
      </div>
      <p className="text-[var(--accent)] uppercase tracking-widest text-xs mb-2">{t("notFound.kicker")}</p>
      <h1 className="font-display text-5xl sm:text-6xl text-[var(--text)] mb-4">{t("notFound.title")}</h1>
      <p className="text-[var(--text-dim)] text-center max-w-md mb-10 leading-relaxed">{t("notFound.description")}</p>
      <div className="flex flex-col sm:flex-row gap-3 items-center">
        <Link to={PROJECTS_LIST_PATH} className="btn-primary px-8 py-3">
          {t("notFound.goProjects")}
        </Link>
        <Link to="/login" className="btn-ghost px-8 py-3 border border-[var(--line)]">
          {t("notFound.goLogin")}
        </Link>
      </div>
    </div>
  );
}
